import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ConsentScreen } from '@/features/mcp/routes/consent-screen'

export const Route = createFileRoute('/oauth/consent')({
  // Loose on purpose: Better Auth signs the whole query string (client_id,
  // scope, state, sig…), and the signature breaks if any of it is dropped or
  // rewritten. Only the app's id is read here.
  validateSearch: z.looseObject({
    client_id: z.string().optional(),
    redirect_uri: z.string().optional(),
  }),
  component: Consent,
})

function Consent() {
  // The tab says "Approve an app" whatever the heading names (consent-screen.tsx).
  return <ConsentScreen />
}
